module.exports = __webpack_public_path__ + "media/images/login-bg-fe492e68e1a46311c2ca44e9ca45c17d.png";